import PDAHeader from "src/components/common/Header";
import { usePDAContainer } from "src/hooks/usePDAContainer";
import PDA1010_R01Chart from "src/containers/PDA/PDA1010_R01/PDA1010_R01Chart";
import { usePDA1010_R01Content } from "./PDA1010_R01Content";
import PDA1010_R01SensorGrid from "src/containers/PDA/PDA1010_R01/PDA1010_R01SensorGrid";
import usePDA1010_R01Store from "./Store_PDA1010_R01";

interface PDA1010_R01ContainerProps {
  menuNm: string;
  menuCd?: string;
  onBack?: () => void;
}

/** 공통 헤더와 카드 목록 또는 상세 차트를 조합하는 화면 컨테이너입니다. */
const PDA1010_R01Container = ({
  menuNm,
  menuCd,
  onBack,
}: PDA1010_R01ContainerProps) => {
  const initData = usePDA1010_R01Store((state) => state.initData);
  const { handleMenuClick } = usePDAContainer(initData);
  const {
    growRoomList,
    packingList,
    waterList,
    coldStorageList,
    selectedCard,
    detailList,
    isLoading,
    handleSensorClick,
    handleDetailBack,
  } = usePDA1010_R01Content(menuCd);

  return (
    <div className="w-full h-screen flex flex-col bg-white fixed inset-0">
      <PDAHeader
        menuNm={menuNm}
        menuCd={menuCd}
        onBack={selectedCard ? handleDetailBack : onBack}
        onMenuClick={handleMenuClick}
      />

      <div className="flex-1 min-h-0 flex flex-col overflow-hidden">
        {/* 카드가 선택되면 상세 차트를, 선택되지 않으면 최신값 카드 목록을 표시합니다. */}
        {selectedCard ? (
          <PDA1010_R01Chart
            card={selectedCard}
            detailList={detailList}
            isLoading={isLoading}
          />
        ) : (
          <PDA1010_R01SensorGrid
            growRoomList={growRoomList}
            packingList={packingList}
            waterList={waterList}
            coldStorageList={coldStorageList}
            isLoading={isLoading}
            onSensorClick={handleSensorClick}
          />
        )}
      </div>
    </div>
  );
};

export default PDA1010_R01Container;
